import {createRouter, createWebHistory} from 'vue-router';
import Swal from "sweetalert2";


import SplashPage from "@/components/SplashPage.vue";
import LoginPage from "@/components/LoginPage.vue";
import OtpPage from "@/components/OtpPage.vue";
import RegisterPage from "@/components/RegisterPage.vue";
import HomePage from "@/components/HomePage.vue";
import DetailsProducts from "@/components/DetailsProducts.vue";
import CategoryPage from "@/components/CategoryPage.vue";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import SearchBy from "@/components/SearchBy.vue";
import CartPage from "@/components/CartPage.vue";
import CartInfoSend from "@/components/CartInfoSend.vue";
import AddAddress from "@/components/AddAddress.vue";
import MyOrders from "@/components/MyOrders.vue";
import ProfilePage from "@/components/ProfilePage.vue";
import WalletPage from "@/components/WalletPage.vue";
import MyProfile from "@/components/MyProfile.vue";
import MarksProducts from "@/components/MarksProducts.vue";
import WebPage from "@/components/WebPage.vue";
import SupportPage from "@/components/SupportPage.vue";
import MyTickets from "@/components/MyTickets.vue";
import OffersPage from "@/components/OffersPage.vue";
import AddOffers from "@/components/AddOffers.vue";
import OffersShop from "@/components/OffersShop.vue";
import FinalPayment from "@/components/FinalPayment.vue";
import AuctionsPage from "@/components/AuctionsPage.vue";
import AuctionInformation from "@/components/AuctionInformation.vue";
import StorePage from "@/components/StorePage.vue";
import MyAuctions from "@/components/MyAuctions.vue";
import ShowAll from "@/components/ShowAll.vue";



const routes = [
    { path: '/test', name: 'BottomNavigation', component: BottomNavigation },


    { path: '/', name: 'SplashPage', component: SplashPage },
    { path: '/LoginPage', name: 'LoginPage', component: LoginPage },
    { path: '/OtpPage/:phone', name: 'OtpPage', component: OtpPage },
    { path: '/HomePage', name: 'HomePage', component: HomePage },
    { path: '/RegisterPage/:phone', name: 'RegisterPage', component: RegisterPage },
    { path: '/DetailsProducts/:pid', name: 'DetailsProducts', component: DetailsProducts },
    { path: '/CategoryPage/:cid', name: 'CategoryPage', component: CategoryPage },
    { path: '/SearchBy/:text', name: 'SearchBy', component: SearchBy },
    { path: '/CartPage', name: 'CartPage', component: CartPage },
    { path: '/CartInfoSend', name: 'CartInfoSend', component: CartInfoSend },
    { path: '/AddAddress', name: 'AddAddress', component: AddAddress },
    { path: '/MyOrders', name: 'MyOrders', component: MyOrders },
    { path: '/ProfilePage', name: 'ProfilePage', component: ProfilePage },
    { path: '/WalletPage', name: 'WalletPage', component: WalletPage },
    { path: '/MyProfile', name: 'MyProfile', component: MyProfile },
    { path: '/MarksProducts', name: 'MarksProducts', component: MarksProducts },
    { path: '/WebPage/:type', name: 'WebPage', component: WebPage },
    { path: '/SupportPage', name: 'SupportPage', component: SupportPage },
    { path: '/MyTickets', name: 'MyTickets', component: MyTickets },
    { path: '/OffersPage', name: 'OffersPage', component: OffersPage },
    { path: '/AddOffers', name: 'AddOffers', component: AddOffers },
    { path: '/OffersShop/:offer_id/:name', name: 'OffersShop', component: OffersShop },
    { path: '/FinalPayment/:oid/:sid', name: 'FinalPayment', component: FinalPayment },
    { path: '/AuctionsPage', name: 'AuctionsPage', component: AuctionsPage },
    { path: '/AuctionInformation/:bid', name: 'AuctionInformation', component: AuctionInformation },
    { path: '/StorePage/:sid/:shopname', name: 'StorePage', component: StorePage },
    { path: '/MyAuctions', name: 'MyAuctions', component: MyAuctions },
    { path: '/ShowAll/:type', name: 'ShowAll', component: ShowAll },
]


const router = createRouter({
    history: createWebHistory(),
    routes
})

let user_id = localStorage.getItem('uid')

router.beforeEach((to, from, next) => {
    Swal.close()

    if (!user_id && to.name !== 'LoginPage' && to.name !== 'OtpPage' && to.name !== 'RegisterPage' && to.name !== 'SplashPage' && to.name !== 'InformationPage' ) {
        next({ name: 'SplashPage' })
    } else {
        next()
    }
})



export default router;